<ngx-charts-line-chart
  [view]="view"
  [results]="data"
  [scheme]="options.colorScheme"
  [legend]="options.legend"
  [legendTitle]= 'options.legendTitle'
  [legendPosition]= 'options.legendPosition'
  [showXAxisLabel]="options.showXAxisLabel"
  [showYAxisLabel]="options.showYAxisLabel"
  [xAxis]="options.xAxis"
  [yAxis]="options.yAxis"
  [xAxisLabel]="options.xAxisLabel"
  [yAxisLabel]="options.yAxisLabel"
  [yScaleMin]="options.yScaleMin"
  [yScaleMax]="options.yScaleMax"
  [timeline]="options.timeline"
  [curve]="options.curve">

  <!-- ngx-charts picks these up via @ContentChild('tooltipTemplate' | 'seriesTooltipTemplate'). -->
  <ng-template #seriesTooltipTemplate let-model="model">
    <div class="area-tooltip-container">
      <span class="tooltip-label">{{ model?.[0]?.name }}</span>
      <div class="tooltip-item" *ngFor="let item of model; trackBy: trackByTooltipSeries">
        <span class="tooltip-item-color" [style.background-color]="item.color"></span>
        {{ item.series }}: {{ item.value | number }}
      </div>
      <span class="tooltip-label" *ngIf="options.tooltipCaption">{{ options.tooltipCaption }}</span>
    </div>
  </ng-template>

  <ng-template #tooltipTemplate let-model="model">
    <span class="tooltip-label">{{ model?.series }} &bull; {{ model?.name }}</span>
    <span class="tooltip-val">{{ model?.value | number }}</span>
    <span class="tooltip-label" *ngIf="options.tooltipCaption">{{ options.tooltipCaption }}</span>
  </ng-template>

</ngx-charts-line-chart>
